import { NoEditPlugin } from '@src/slide/application/no-edit/plugins/no-edit-plugin';
import { ISharePluginBase } from '@src/slide/application/no-edit/plugins/share/base/base/share-plugin-base.interface';
import { getShareLinkFn } from '@src/slide/application/no-edit/plugins/share/share-utils';
import {
    browser, removeURLParameter,
    updateQueryStringParameter,
} from '@src/slide/application/service/edit-extension/edit-extension-export';
import { IAuthPluginBase } from '@src/slide/application/no-edit/plugins/auth/base/base/auth-plugin-base.interface';
import { ILoginPlugin, LOGIN_PLUGIN_NAME } from '@src/slide/application/no-edit/plugins/login/login-plugin.interface';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { IBaseEditorExtensionService } from '@src/slide/application/service/edit-extension/core/editor/base/interface';

/**
 * 技术文档：
 * https://doc.weixin.qq.com/doc/w3_ADEA_wY9ACozcpTvQZ1T3qEWSpFQv?scode=AJEAIQdfAAovZKTZ09ADEA_wY9ACo
 *
 * 小程序根据收到的SHARE_FLAG
 * 0 => ${docInfo.doc_url}?convert_type=image 根据参数reload页面唤起生成长图
 * 1 => 跳转中转页scenario/miniprogram-trans-data.html开始轮询唤起生成长图
 **/
const SHARE_FLAG = '1';

/**
 * 分享plugin基类，抽象公用逻辑
 */
export default class SharePluginBase extends NoEditPlugin implements ISharePluginBase {
    declare protected editExtensionService?: IBaseEditorExtensionService;

    public initPlugin(): void {

    }

    public getShareLink(needOriginUrl?: boolean): string {
        return getShareLinkFn(needOriginUrl);
    }

    /**
     * 微信小程序，跳转到分享面板。
     */
    public navigateToSharePanel(): void {
        if (browser.isMiniProgram && window.wx && window.wx.miniProgram) {
            const url = this.getMiniProgramSharePanelUrl();
            window.wx.miniProgram.navigateTo({ url });
        }
    }

    /**
     * 获取小程序中分享面板的url
     */
    public getMiniProgramSharePanelUrl(): string {
        let resultUrl = window.location.href;
        // drive文件需要取drive链接，否则鉴权不通过
        if (window.basicClientVars?.docInfo?.shareLink) {
            // 这里的链接格式有问题，会丢失https，值为//docs.qq.com/document/xxx
            resultUrl = window.basicClientVars.docInfo.shareLink;
            if (!resultUrl.startsWith('https:')) {
                resultUrl = `https:${resultUrl}`;
            }
        }
        const userInfo = this.getUserInfo();
        const ownerAvatar = userInfo?.avatar || '';
        const ownerUsername = userInfo?.nick || '';
        const ownerUid = userInfo?.uid;

        const isAuthExpExpire = this.getAuthPlugin()?.getAuth()
            .isAuthExpired() || false;
        const hasWatermark = false;
        const {
            policy: guestPolicy,
            padType, isCreator, padId, domainId, creatorDomain } = SlideDataServices.DocInfoManager() ?? {};
        const { title = '' } = SlideDataServices.SlideTitleManager() ?? {};
        const type = 4; // slide

        resultUrl = removeURLParameter(resultUrl, '__wxjs_environment');
        resultUrl = removeURLParameter(resultUrl, 'user_info');
        resultUrl = removeURLParameter(resultUrl, 'session');
        resultUrl = removeURLParameter(resultUrl, 'uid');
        resultUrl = removeURLParameter(resultUrl, 'uid_key');
        resultUrl = removeURLParameter(resultUrl, 'disableReturnList');
        resultUrl = removeURLParameter(resultUrl, 'TOK');
        resultUrl = removeURLParameter(resultUrl, 'receive');
        resultUrl = removeURLParameter(resultUrl, '_r');
        resultUrl = removeURLParameter(resultUrl, '_from');
        resultUrl = removeURLParameter(resultUrl, '_localnum');
        resultUrl = removeURLParameter(resultUrl, 'fromTrash');
        const url = updateQueryStringParameter('/pages/sharePanel/sharePanel', {
            padId,
            domainId,
            type,
            isCreator,
            padType,
            title: encodeURIComponent(title),
            url: encodeURIComponent(resultUrl),
            creatorDomain,
            owner_avatar: encodeURIComponent(ownerAvatar),
            owner_username: encodeURIComponent(ownerUsername),
            owner_uid: ownerUid,
            isAuthExpExpire,
            hasWatermark,
            guestPolicy,
            detailShare: SHARE_FLAG,
        });
        return url;
    }

    /**
     * 获取权限plugin name, PC和Mobile不一样，由子类重写
     */
    protected getAuthPluginName(): string {
        return '';
    }

    protected getAuthPlugin(): IAuthPluginBase | undefined {
        return this.noEditService?.getPluginSync<IAuthPluginBase>(this.getAuthPluginName());
    }

    private getUserInfo() {
        const loginPlugin = this.noEditService?.getPluginSync<ILoginPlugin>(LOGIN_PLUGIN_NAME);
        return loginPlugin?.userInfo;
    }
}
